/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  IReInviteMethods,
  ReInviteUserService,
  ISettingsMethods,
  UserListsService,
  IUserListsMethods,
  IRecallInviteMethods,
  RecallInviteUserService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IGetCommitteeMethods,
  GetCommitteeService
} from "./components";

export type InviteesListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IReInviteMethods &
  IRecallInviteMethods &
  IGetCommitteeMethods &
  IUserListsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new UserListsService(),
    new ReInviteUserService(),
    new RecallInviteUserService(),
    new GetCommitteeService(),
  ];
};

export const getAgent = () => {
  return createAgent<InviteesListPageAgent>({
    plugins: getPlugins(),
  });
};
